import { useEffect, useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import CreateProductoModal from "../productos/CreateProductoModal";

function ProductosForm({
  productos,
  productsList,
  setProductsList,
  setTotalProductos,
  selectedClient,
  setProductos,
  formaDePago,
  largoPelo
}) {
  const handleAdd = () => {
    setProductsList([
      ...productsList,
      { id: "", producto: "", marca: "", precio: 0, stock: 0 },
    ]);
  };

  const handleRemove = (index) => {
    const list = [...productsList];
    list.splice(index, 1);
    setProductsList(list);
  };

  const handleSelect = (e, index) => {
    const list = [...productsList];
    // Recibimos el id del producto elegido en el select
    const productId = e.target.value;
    // Si el usuario selecciona el default, hacemos lo mismo con el object
    if (productId === "") {
      list[index] = { id: "", producto: "", marca: "", precio: 0, stock: 0 };
      setProductsList(list);
    } else {
      // Buscamos el object en productos a partir del id
      const p = productos.find((u) => u.id === parseInt(productId));
      let precio = 0;

      if (parseInt(formaDePago) === 0 || parseInt(formaDePago) === 2) {
        precio = p.precio;
      } else if (parseInt(formaDePago) === 1 || parseInt(formaDePago) === -1) {
        precio = p.tarjeta;
      }

      // Armamos la el objeto que vamos a guardar en 'productsList'
      list[index]["id"] = p.id;
      list[index]["producto"] = p.producto;
      list[index]["marca"] = p.marca;
      list[index]["precio"] = precio;
      list[index]["stock"] = p.stock;
      setProductsList(list);
    }
  };

  // Esta variable lleva la cuenta del total de los productos
  let total = productsList.reduce(
    (sum, value) => sum + parseFloat(value.precio),
    0
  );

  useEffect(() => {
    setTotalProductos(total);
  }, [productsList]);

  useEffect(() => {
    setProductsList([]);
  }, [formaDePago, selectedClient, largoPelo]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <h4>Productos:</h4>
        <CreateProductoModal
          productos={productos}
          setProductos={setProductos}
        />
      </div>
      {productsList.map((singleProduct, index) => (
        <Row key={index} className="d-flex justify-content-center mt-4">
          <Form.Group className="mb-3" as={Col} lg={4}>
            <Form.Label>Producto {index + 1}</Form.Label>
            <Form.Select
              onChange={(e) => {
                handleSelect(e, index);
              }}
            >
              <option value={""}>Seleccionar Producto {index + 1}</option>
              {productos.length > 0
                ? productos.map((producto) => {
                    if (producto.stock > 0) {
                      return (
                        <option key={producto.id} value={producto.id}>
                          {producto.producto}
                        </option>
                      );
                    }
                  })
                : "No hay productos"}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" as={Col} lg={2}>
            <Form.Label>Precio</Form.Label>
            <Form.Control disabled value={`$ ${singleProduct.precio}`} />
          </Form.Group>

          <Form.Group className="mb-3" as={Col} lg={2}>
            <Form.Label>Stock</Form.Label>
            <Form.Control disabled value={`${singleProduct.stock} u`} />
          </Form.Group>
        </Row>
      ))}

      {productsList.length === 0 && (
        <div className="mt-4  d-flex justify-content-center">
          <h5 className="text-muted">Agregar Producto</h5>
        </div>
      )}

      <div className="d-flex justify-content-center mt-3">
        {(productsList.length < 6) & (selectedClient.length !== 0) ? (
          <button
            type="button"
            className="btn btn-success btn-sm m-1"
            onClick={handleAdd}
          >
            +
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-dark btn-sm m-1  disabled"
            onClick={handleAdd}
          >
            +
          </button>
        )}
        {productsList.length > 0 ? (
          <button
            type="button"
            className="btn btn-danger btn-sm m-1"
            onClick={() => handleRemove(productsList.length - 1)}
          >
            -
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-dark btn-sm m-1 disabled"
            onClick={() => handleRemove(productsList.length - 1)}
          >
            -
          </button>
        )}
      </div>

      {productsList.length > 0 && (
        <div className="mt-4  d-flex justify-content-center">
          <h5>Total Productos: $ {total}</h5>
        </div>
      )}
    </>
  );
}

export default ProductosForm;
